import { render, staticRenderFns } from "./SupplierPaymentsList.vue?vue&type=template&id=1a4e6f9f&scoped=true&"
import script from "./SupplierPaymentsList.vue?vue&type=script&lang=js&"
export * from "./SupplierPaymentsList.vue?vue&type=script&lang=js&"
import style1 from "./SupplierPaymentsList.vue?vue&type=style&index=1&id=1a4e6f9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e6f9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VContainer,VDataTable,VRow})
